import { render } from "./UserIdManageComponent.vue?vue&type=template&id=3f08aa1e&scoped=true"
import script from "./UserIdManageComponent.vue?vue&type=script&lang=js"
export * from "./UserIdManageComponent.vue?vue&type=script&lang=js"

import "./UserIdManageComponent.vue?vue&type=style&index=0&id=3f08aa1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f08aa1e"]])

export default __exports__